export const MONTHLY_PERCENTAGE_MALE = 25;
export const MONTHLY_PERCENTAGE_FEMALE = 35;
export const TWICEMONTHLY_PERCENTAGE_MALE = 30;
export const TWICEMONTHLY_PERCENTAGE_FEMALE = 41;
